// extracted by mini-css-extract-plugin
module.exports = {"CustomAccordionContainer":"CustomAccordion_CustomAccordionContainer__2UNrF","Trigger":"CustomAccordion_Trigger__20en0","Count":"CustomAccordion_Count__1QY4_"};